const PowerIcon: React.FC = () => {
  return (
    <svg
      width="54"
      height="51"
      viewBox="0 0 54 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.8235 9.04473C26.2665 8.89103 25.6824 9.14253 25.3971 9.6595L15.1681 28.005C14.9372 28.4102 14.9508 28.8992 15.1681 29.3044C15.3991 29.7096 15.8066 29.9611 16.2685 29.9611H25.2341V41.6978C25.2341 42.2846 25.6145 42.8016 26.1714 42.9553C26.7284 43.109 27.3125 42.8575 27.5978 42.3405L37.8268 24.0788C38.0577 23.6736 38.0577 23.1846 37.8268 22.7794C37.5959 22.3742 37.1883 22.1227 36.7265 22.1227H27.7608V10.3022C27.7608 9.71539 27.3669 9.18445 26.8235 9.04473Z"
        fill="#25C16F"
      />
      <path
        d="M50 21C48.0453 10.192 38.5628 2 27.1257 2C16.7699 2 8.00832 8.74638 5 18.0399"
        stroke="#A8E6C5"
        stroke-width="3.29849"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M50.6662 26L54 18L45 19.7133L50.6662 26Z" fill="#A8E6C5" />
      <path
        d="M4 30C5.95111 40.7942 15.4161 49 26.8183 49C37.2795 49 46.1079 42.1159 49 32.6435"
        stroke="#A8E6C5"
        stroke-width="3.29849"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M3.33382 25L0 33L9 31.2979L3.33382 25Z" fill="#A8E6C5" />
    </svg>
  );
};

export default PowerIcon;
